import { useSyncExternalStore } from 'react'
import { Folder20Regular } from '@/components/Icon'
import { DESIGN_PREVIEW_PROJECT_OPTIONS } from '@/components/DocumentPreview/designPreviewProjectOptions'
import { createId } from '@/features/chat/chatIds'


/** @typedef {import('@/components/DocumentPreview/designPreviewProjectOptions').DesignPreviewProjectOption} DesignPreviewProjectOption */

/** @type {DesignPreviewProjectOption[]} */
let designPreviewProjects = [...DESIGN_PREVIEW_PROJECT_OPTIONS]

/** @type {string} */
let activeDesignPreviewProjectId = designPreviewProjects[0].id

/** @type {Set<() => void>} */
const projectListeners = new Set()

/** @type {Set<() => void>} */
const activeIdListeners = new Set()

export function getDesignPreviewProjects() {
  return designPreviewProjects
}

export function getDesignPreviewProjectId() {
  return activeDesignPreviewProjectId
}

/** @param {string} projectId */

export function setDesignPreviewProjectId(projectId) {
  if (activeDesignPreviewProjectId === projectId) return
  activeDesignPreviewProjectId = projectId
  for (const listener of activeIdListeners) listener()
}

/** @param {string} name */

export function addDesignPreviewProject(name) {
  const label = name.trim()
  if (!label) return null

  const project = {
    id: createId(),
    label,
    Icon: Folder20Regular,
  }

  designPreviewProjects = [project, ...designPreviewProjects]
  for (const listener of projectListeners) listener()
  setDesignPreviewProjectId(project.id)
  return project
}

export function resetDesignPreviewProjectId() {
  designPreviewProjects = [...DESIGN_PREVIEW_PROJECT_OPTIONS]
  for (const listener of projectListeners) listener()
  setDesignPreviewProjectId(DESIGN_PREVIEW_PROJECT_OPTIONS[0].id)
}

/** @param {() => void} listener @returns {() => void} */

export function subscribeDesignPreviewProjects(listener) {
  projectListeners.add(listener)
  return () => projectListeners.delete(listener)
}

export function subscribeDesignPreviewProjectId(listener) {
  activeIdListeners.add(listener)
  return () => activeIdListeners.delete(listener)
}
